/**
 * Feature Flags for SceneFeed
 * Control rollout of new architecture features
 */

const FEATURE_FLAGS = {
  // New Architecture Features
  USE_NEW_AUTH_SERVICE: process.env.REACT_APP_USE_NEW_AUTH === 'true',
  USE_NEW_USER_SERVICE: process.env.REACT_APP_USE_NEW_USER_SERVICE === 'true',
  USE_SCENE_POINTS_SYSTEM: process.env.REACT_APP_USE_SCENE_POINTS === 'true',
  USE_NEW_APPROVAL_SYSTEM: process.env.REACT_APP_USE_NEW_APPROVAL === 'true',
  
  // Development and Migration flags
  ENABLE_DEBUG_LOGGING: process.env.NODE_ENV === 'development',
  SHOW_MIGRATION_STATUS: process.env.REACT_APP_SHOW_MIGRATION_STATUS === 'true',
  ENABLE_DUAL_AUTH: process.env.REACT_APP_ENABLE_DUAL_AUTH === 'true',
  
  // Safety flags
  ALLOW_FALLBACK_AUTH: process.env.REACT_APP_ALLOW_FALLBACK_AUTH !== 'false',
  ENABLE_AUTH_LOGGING: process.env.REACT_APP_ENABLE_AUTH_LOGGING === 'true'
};

// Helper functions
export const isFeatureEnabled = (featureName) => {
  return FEATURE_FLAGS[featureName] || false;
};

export const logFeatureUsage = (featureName, action = 'used') => {
  if (FEATURE_FLAGS.ENABLE_DEBUG_LOGGING) {
    console.log(`🚩 Feature Flag: ${featureName} ${action}`);
  }
};

export const getActiveFeatures = () => {
  return Object.entries(FEATURE_FLAGS)
    .filter(([key, value]) => value === true)
    .map(([key]) => key);
};

export default FEATURE_FLAGS;
